import { useState, useEffect } from "react";
import { MdSearch, MdOutlineDoubleArrow } from "react-icons/md";
import useSeasonDetails from "../hooks/useSeasonDetails";

function formatWert(wert) {
    if (wert === undefined || wert === null || wert === "") {
        return "–";
    }
    return `${Number(wert).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}

function GewinnerlisteTable(props) {
    const { data: seasonData } = useSeasonDetails();

    const [preisliste, setPreisliste] = useState([]);
    const maxPage = Math.max(0, parseInt(preisliste.length / 10));
    const [currentPage, setCurrentPage] = useState(0);
    const [displayablePrizes, setDisplayablePrizes] = useState([]);
    const [prizeFound, setPrizeFound] = useState(undefined);

    useEffect(() => {
        fetch("/config/gewinnerliste.json")
            .then((res) => res.json())
            .then((data) => setPreisliste(data))
            .catch((err) => console.error("Failed to load gewinnerliste.json:", err));
    }, []);

    useEffect(() => {
        setDisplayablePrizes(preisliste.slice(currentPage * 10, currentPage * 10 + 10))
    }, [currentPage, preisliste])

    function findPrize() {
        let inp = document.getElementById("prizeSearch");
        let found = preisliste.find((item) => item.startnummer === Number(inp.value));
        if (found !== undefined) {
            setPrizeFound(found)
        } else {
            setPrizeFound(null);
        }

    }

    function changeCurrentPage(num) {
        if (currentPage === 0 && num < 0) {
            return;
        }
        if (currentPage === maxPage && num > 0) {
            return;
        }
        setCurrentPage(currentPage + num);
    }





    return (
        <div className="bg-white rounded-2xl py-8">
            <div className="px-4">
                <div className="text-2xl text-golden w-full font-bold">
                    Alle Platzierungen
                </div>
                <div className="text-blue-dark mt-4">
                    <p>
                        Das waren die Gewinner des {seasonData?.["entencup-number"] || 17}. Dresdner Entencups <b>{seasonData?.year || 2025}</b>!
                    </p>


                </div>
                <div className="flex flex-col md:flex-row mt-8 items-center">
                    <div className="text-lg">
                        <input id="prizeSearch" className="p-2 md:p-4 bg-white border-2 border-blue-dark rounded-full" placeholder="Startnummer eingeben" type="number" />
                    </div>
                    <div className="mt-1 md:ml-8">
                        <div className="font-bold p-2 md:p-4 bg-golden rounded-full cursor-pointer flex flex-row text-white" onClick={(e) => {
                            findPrize();
                        }}>
                            <MdSearch size={30} /> Suchen
                        </div>
                    </div>

                </div>
            </div>

            <div className={`${prizeFound !== undefined && prizeFound !== null ? "" : "hidden"}`}>
                {prizeFound && <div className="text-blue-dark">
                    <div className="hidden md:block">
                        <div className="grid grid-cols-7 p-4 font-bold">
                            <div>Platz</div>
                            <div>Startnummer</div>
                            <div>Wert</div>
                            <div className="col-span-3">Preis</div>
                        </div>
                        <hr />
                        <div className="grid grid-cols-7 p-4">
                            <div>{prizeFound.platz}</div>
                            <div>{prizeFound.startnummer}</div>
                            <div>{formatWert(prizeFound.wert)}</div>
                            <div className="col-span-3">
                                <div>
                                    {prizeFound.preis}
                                </div>
                                {prizeFound.preis_extra && <div></div>}
                            </div>
                        </div>
                    </div>
                    <div className="block md:hidden">
                        <div className="grid grid-cols-2 p-4">
                            <div className="mb-4">Platz</div>
                            <div>{prizeFound.platz}</div>

                            <div className="mb-4">Startnummer</div>
                            <div>{prizeFound.startnummer}</div>
                            <div className="mb-4">Wert</div>
                            <div>{formatWert(prizeFound.wert)}</div>
                            <div className="mb-4">Preis</div>
                            <div className="">
                                <div>
                                    {prizeFound.preis}
                                </div>
                                {prizeFound.preis_extra && <div></div>}
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            <div className={`${prizeFound === null ? "" : "hidden"} p-4`}>
                <i>Es gibt leider keinen Preis für diese Startnummer</i>
            </div>

            <div className="mt-8 text-blue-dark">
                <div className="font-bold p-4">
                    {currentPage * 10 + 1} - {(currentPage * 10 + 11 > preisliste.length ? preisliste.length : currentPage * 10 + 10)} von {preisliste.length} Ergebnissen
                </div>
                <div className="pb-8">
                    <hr />
                    <div className="grid grid-cols-4 md:grid-cols-7 p-4 font-bold">
                        <div>Platz</div>
                        <div>Startnummer</div>
                        <div className="hidden md:block">Wert</div>
                        <div className="col-span-2 md:col-span-3 md:block text-right md:text-left">Preis</div>
                    </div>
                    <hr />
                    {displayablePrizes.map((prize, index) => {
                        return (
                            <div key={index}>
                                <div className="grid grid-cols-4 md:grid-cols-7 p-4">
                                    <div>{prize.platz}</div>
                                    <div>{prize.startnummer}</div>
                                    <div className="hidden md:block">{formatWert(prize.wert)}</div>
                                    <div className="col-span-2 md:col-span-3 whitespace-normal md:block pr-2">
                                        <div>
                                            {prize.preis}
                                        </div>
                                        {prize.wert != null && (
                                            <div className="md:hidden text-sm mt-1">{formatWert(prize.wert)}</div>
                                        )}
                                        {prize.preis_extra && <div></div>}
                                    </div>
                                </div>
                                <hr />
                            </div>
                        )
                    })}
                </div>

            </div>

            <div className="flex flex-row justify-center items-center">
                <div
                    className={`${currentPage === 0 ? "disabled bg-blue-300 cursor-not-allowed" : "cursor-pointer bg-blue-light"} 
                    select-none p-1 md:p-4 text-white rounded-full mx-2 md:mx-8 font-bold flex flex-row items-center`}
                    onClick={(e) => { changeCurrentPage(-1) }}
                >
                    <MdOutlineDoubleArrow size={20} className="transform rotate-180" /> Vorgerige
                </div>
                <div className="text-md md:text-2xl font-bold text-blue-dark select-none">{currentPage + 1} / {parseInt(preisliste.length / 10) + 1}</div>
                <div
                    className={`${currentPage === maxPage ? "disabled bg-blue-300 cursor-not-allowed" : "cursor-pointer bg-blue-light"} 
                    select-none p-1 md:p-4 text-white  rounded-full mx-2 md:mx-8 font-bold flex flex-row items-center`}
                    onClick={(e) => { changeCurrentPage(1) }}
                >
                    Nächste <MdOutlineDoubleArrow size={20} />
                </div>

            </div>


        </div>
    );
}

export default GewinnerlisteTable;
